import { Button, Typography } from '@mui/material';
import { v4 } from '@rotra-air-ocean/rotranext-shared-code';

import { EMAIL_CONTEXT_FIELDS } from '$layouts/v2/helpers/context';

import { Modal } from '../Modal';

import { FieldsEditor } from './fields/FieldsEditor';

const RESERVED_WORKFLOW_INPUT_NAMES = EMAIL_CONTEXT_FIELDS.map(
  (field) => field.name,
);

/** Declares this workflow's reusable inputs and outputs. */
export function WorkflowInputsModal({
  inputs,
  outputs,
  inputTypes,
  onClose,
  onChangeInputs,
  onChangeOutputs,
  readOnly = false,
}: {
  inputs: v4.FieldSpec[];
  outputs: v4.FieldSpec[];
  inputTypes: v4.FieldInputType[];
  onClose: () => void;
  onChangeInputs: (inputs: v4.FieldSpec[]) => void;
  onChangeOutputs: (outputs: v4.FieldSpec[]) => void;
  /** Opens the workflow contract for inspection without allowing changes. */
  readOnly?: boolean;
}) {
  return (
    <Modal
      title="Inputs & outputs"
      onClose={onClose}
      actions={
        <Button variant="contained" onClick={onClose}>
          {readOnly ? 'Close' : 'Done'}
        </Button>
      }
    >
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
        }}
      >
        {readOnly
          ? 'These are the inputs this workflow needs and the outputs it returns when used as a sub-workflow. Callers map inputs from their context and map outputs back.'
          : 'Declare what this workflow needs and returns when used as a sub-workflow. Callers map inputs from their context and map outputs back. Declaring any input or output marks this as a reusable sub-workflow.'}
      </Typography>
      <FieldsEditor
        label="Inputs (callers must provide)"
        fields={inputs}
        inputTypes={inputTypes}
        onChange={onChangeInputs}
        readOnly={readOnly}
        reservedNames={RESERVED_WORKFLOW_INPUT_NAMES}
      />
      <FieldsEditor
        label="Outputs (returned to the caller)"
        fields={outputs}
        inputTypes={inputTypes}
        onChange={onChangeOutputs}
        readOnly={readOnly}
      />
    </Modal>
  );
}
